import React from "react";
import "./App.css";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import ExternalCommonWinpayGo from "./pages/ExternalCommonWinpayGo";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact>
          <Redirect to="/external-winpay-go" />
        </Route>
        <Route
          path="/external-winpay-go"
          component={ExternalCommonWinpayGo}
          exact
        />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
